module.exports = __webpack_public_path__ + "static/media/nfc.35ad3697.png";